import * as Yup from 'yup';

const TrainingProgramsScheme = Yup.object().shape({
  title: Yup.string().trim().required('Title is required'),
  // duration: Yup.number()
  //   .typeError('Value must be a number')
  //   .required('Duration is required'),
  // description: Yup.string().trim().required('Description is required'),
  // format: Yup.string().trim().required('Format is required'),
  // status: Yup.string().trim().required('Status is required'),
  //   mandatory: Yup.boolean().required('Is Mandatory is required'),
  ai_rmf_domains: Yup.array()
    .required('Risk Management Framework is required')
    .min(1, 'Please select atleast one'),
  training_definition: Yup.array()
    .required('Training Step is required')
    .min(1, 'Please add training step atleast one'),
  // prerequisites: Yup.array()
  //   .required('Prerequisites is required')
  //   .min(1, 'Please add atleast one'),
  // learning_objectives: Yup.array()
  //   .required('Learning Objectives is required')
  //   .min(1, 'Please add atleast one'),
  role: Yup.array()
    .required('Roles is required')
    .min(1, 'Please select atleast one'),
  // recurrence_months: Yup.number()
  //   .typeError('Value must be a number')
  //   .required('Recurrence is required'),
  // certification_valid_months: Yup.number()
  //   .typeError('Value must be a number')
  //   .required('Certification Valid Months is required'),
});

const TrainingProgramsExternalScheme = Yup.object().shape({
  title: Yup.string().trim().required('Title is required'),
  status: Yup.string().trim().required('Status is required'),
  external_urls: Yup.array()
    .of(
      Yup.object().shape({
        name: Yup.string().trim().trim().required('Name is required'),
        url: Yup.string()
          .trim()
          .trim()
          .required('URL is required')
          .url('Must be a valid URL'),
      })
    )
    .required("External URL's is required")
    .min(1, 'Please add at least one'),
  external_provider: Yup.string()
    .trim()
    .required('External provider is required'),
  ai_rmf_domains: Yup.array()
    .required('Risk Management Framework is required')
    .min(1, 'Please select atleast one'),
  prerequisites: Yup.array()
    .required('Prerequisites is required')
    .min(1, 'Please add atleast one'),
  learning_objectives: Yup.array()
    .required('Learning Objectives is required')
    .min(1, 'Please add atleast one'),
  duration_minutes: Yup.number()
    .typeError('Value must be a number')
    .required('Duration is required'),
  role: Yup.array()
    .required('Roles is required')
    .min(1, 'Please select atleast one'),
});

export { TrainingProgramsScheme, TrainingProgramsExternalScheme };
